import { ListItemButton } from '@mui/material';
import MuiListItem from '@mui/material/ListItem';
import { FC, PropsWithChildren } from 'react';

interface ListItemProps {
  onClick?: () => void;
}

const defaultProps = {
  onClick: undefined,
};

const ListItem: FC<PropsWithChildren<ListItemProps>> = ({ children, onClick }) => (
  <MuiListItem disablePadding>
    <ListItemButton onClick={onClick}>{children}</ListItemButton>
  </MuiListItem>
);

ListItem.defaultProps = defaultProps;

export default ListItem;
